import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getDrawingToolControlData,
  setControlData,
} from '../../../../../store/lixaniPaint/slices/drawingToolSlice';

export const GlobalSettings = () => {
  const dispatch = useDispatch();
  const controlData = useSelector(getDrawingToolControlData);

  const handleLineColorChange = (e) => {
    dispatch(setControlData({ lineColor: e.target.value }));
  };

  const handleLineWidthChange = (e) => {
    dispatch(setControlData({ lineWidth: parseInt(e.target.value) }));
  };

  const handleFillColorChange = (e) => {
    dispatch(setControlData({ fillColor: e.target.value }));
  };

  const handleFillOpacityChange = (e) => {
    dispatch(setControlData({ fillOpacity: parseFloat(e.target.value) }));
  };

  const handleFontSizeChange = (e) => {
    dispatch(setControlData({ fontSize: parseInt(e.target.value) }));
  };

  const handleTextColorChange = (e) => {
    dispatch(setControlData({ textColor: e.target.value }));
  };

  return (
    <div style={{ padding: '12px', color: 'white' }}>
      <div style={{ marginBottom: '12px' }}>
        <label
          style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}
        >
          Viiva
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="color"
            value={controlData.lineColor || '#000000'}
            onChange={handleLineColorChange}
            style={{
              width: '32px',
              height: '24px',
              border: 'none',
              borderRadius: '4px',
            }}
          />
          <input
            type="range"
            min="1"
            max="10"
            value={controlData.lineWidth || 2}
            onChange={handleLineWidthChange}
            style={{ flex: 1 }}
          />
          <span style={{ fontSize: '12px', minWidth: '30px' }}>
            {controlData.lineWidth || 2}px
          </span>
        </div>
      </div>

      <div style={{ marginBottom: '12px' }}>
        <label
          style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}
        >
          Täyttö
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="color"
            value={controlData.fillColor || '#0000ff'}
            onChange={handleFillColorChange}
            style={{
              width: '32px',
              height: '24px',
              border: 'none',
              borderRadius: '4px',
            }}
          />
          <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={controlData.fillOpacity || 0.3}
            onChange={handleFillOpacityChange}
            style={{ flex: 1 }}
          />
          <span style={{ fontSize: '12px', minWidth: '30px' }}>
            {Math.round((controlData.fillOpacity || 0.3) * 100)}%
          </span>
        </div>
      </div>

      <div style={{ marginBottom: '12px' }}>
        <label
          style={{ display: 'block', marginBottom: '4px', fontSize: '13px' }}
        >
          Teksti
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="color"
            value={controlData.textColor || '#000000'}
            onChange={handleTextColorChange}
            style={{
              width: '32px',
              height: '24px',
              border: 'none',
              borderRadius: '4px',
            }}
          />
          <input
            type="range"
            min="8"
            max="48"
            value={controlData.fontSize || 16}
            onChange={handleFontSizeChange}
            style={{ flex: 1 }}
          />
          <span style={{ fontSize: '12px', minWidth: '30px' }}>
            {controlData.fontSize || 16}px
          </span>
        </div>
      </div>
    </div>
  );
};
